// LoadingSpinner.js
import React from "react";
import {
  LoadingText,
  SpinnerCircle,
  SpinnerWrapper
} from "components/PageLoader/styled";

const LoadingSpinner = ({ size, color, text, fontSize ,className}) => {
  return (
    <SpinnerWrapper className={className}>
      <SpinnerCircle size={size} color={color} />
      {text && (
        <LoadingText color={color} fontSize={fontSize}>
          {text}
        </LoadingText>
      )}
    </SpinnerWrapper>
  );
};

export default LoadingSpinner;
